<template>
  <div>
    <h1>{{ $t("tripPlan.create") }}</h1>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

    <path-crud
      :model="model"
      :isEdit="false"
      :modelstate="modelstate"
    ></path-crud>

    <b-button @click="savePath" :disabled="submitted">
      {{ $t("geral.save") }}
    </b-button>

    <!-- {{ model }} -->
  </div>
</template>
<script>
export default {
  name: "ProcessPathCreate",
  components: {
    PathCrud: () => import("@/components_rms/workflow/Path/PathCrud.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  props: {
    id: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro criado com sucesso",
      },
      submitted: false,
      paths: [],
      model: {
        companyId: 0,
        description: "",
        id: 0,
        imagePath: "",
        maxSpeed: 0.0,
        maxRpm: 0.0,
        name: "",
        totalDistance: 0.0,
        totalSeconds: 0.0,
        cTEWillBeEndorsed: false,
        issueDocument: false,
        displacementType: 1,
        waypoints: [
          // {
          //   id: null,
          //   sequenceNumber: 1,
          //   name: "",
          //   fullAddress: "",
          //   tripPlanWaypointsType: 1,
          //   latitude: -26.474460,
          //   longitude: -49.019342,
          //   altitude: 0.0,
          //   altitudeReference: 0.0,
          //   minutesTravel: 0,
          //   minutesStay: 0,
          //   minutesAdditional: 0,
          //   distance: 0.0,
          //   bingWaypoint: null,
          // },
          // {
          //   sequenceNumber: 2,
          //   name: "Meiuca da jurupinga",
          //   fullAddress: "",
          //   tripPlanWaypointsType: "",
          //   latitude: -26.482113,
          //   longitude: -49.068286,
          //   altitude: 0.0,
          //   altitudeReference: 0.0,
          //   minutesTravel: 0,
          //   minutesStay: 0,
          //   minutesAdditional: 0,
          //   distance: 0.0,
          //   bingWaypoint: null,
          // },
        ],
      },
      modelstate: {},
    };
  },
  created() {
    if (this.id) this.cloneTripPlan();
  },
  methods: {
    savePath() {
      this.submitted = true;
      this.$apiWorkflow
        .post("/tripPlan/save/", this.model)
        .then((response) => {
          this.model = response.data;
          this.$forceUpdate();
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
        })
        .catch((error) => {
          console.log(error.response);
          this.submitted = false;
          this.modelstate = {};
          if (error.response) {
            if (error.response.status == 400) {
              if (error.response.data.errors) {
                this.modelstate = error.response.data.errors;
              } else {
                this.modelstate = error.response.data;
              }
              this.alert.error = error.message;
            } else if (error.response.status == 404) {
              console.log("ok");
              console.log(error.response.data);
              this.alert.error = error.response.data.message;
            } else {
              if (error.response.data) {
                console.log(error.response.data);
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              }
            }
          } else {
            this.alert.error = error.message;
          }
          this.$refs.fadeAlertDanger.show();
        });
    },
    cloneTripPlan() {
      this.$apiWorkflow.get("/tripPlan/clone/" + this.id).then((response) => {
        this.model = response.data;
        console.log(this.model);
      });
    },
  },
};
</script>
